import React, { PureComponent } from 'react';

class WithHandler extends PureComponent {
  constructor(props) {
    super(props);
    this.state = { error: false };
  }

  componentDidCatch(error) {
    this.setState({ error: error.message });
  }

  render() {
    const { children } = this.props;
    const { error } = this.state;

    return (
      <div>
        {
          !error
            ? (
              <div>
                {children}
              </div>
            ) : (
              <div>
                <h1>
                  {error}
                </h1>
              </div>
            )
        }
      </div>
    );
  }
}

export default WithHandler;
